<template>
  <div>
    <div style="padding: 10px" v-show="folderDepthList.length>0">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <a @click="queryByPid(0)">{{$t('moduleTitles.root')}}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item,index) in folderDepthList" :key="index">
          <a @click="queryByPid(item.id)">{{item.name}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoadMore" :immediate-check="false">
        <van-checkbox-group ref="checkboxGroup" v-model="selectedRowKeys">
          <div class="material-wrapper" v-for="(material) in materialList" :key="type +　material.id">
            <div class="info-wrapper">
              <div
                class="left-wrapper"
                v-if="material.dir_id == undefined"
                @click="toFolder(material.id)"
              >
                <div>
                  <img style="width: 40px; height: 40px" src="@/assets/img/fold.png" />
                </div>
                <div class="material-info">
                  <div class="info-title">{{material.name}}</div>
                </div>
              </div>
              <div class="left-wrapper" v-else @click="previewModal(material)">
                <div>
                  <img class="imgs" v-if="type==1" :src="material.url" />
                  <img class="imgs"
                    v-if="type==2"
                    src="@/assets/img/music.png"
                  />
                  <img class="imgs"
                    v-if="type==3"
                    src="@/assets/img/video.png"
                  />
                  <img class="imgs"
                    v-if="type==4"
                    :src="material.cover"
                  />
                  <img class="imgs"
                    v-if="type==5"
                    :src="material.cover"
                  />
                </div>
                <div class="material-info">
                  <div class="info-title">{{material.name}}</div>
                  <div class="info-description">{{material.create_time+" "+material.filesize }}</div>
                </div>
              </div>
              <div class="right-wrapper">
                <van-checkbox  class="checkboxes" :name="material.id" :icon-size="16"></van-checkbox>
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </van-pull-refresh>
    <batch-operate :selected-keys="selectedRowKeys" @close="onBatchClose" @all="onBatchAll">
      <batch-operate-item :text="$t('actionTitles.delete')" @click="batchDelete">
        <template v-slot:icon>
          <a-icon type="delete" />
        </template>
      </batch-operate-item>
      <!-- 重命名編輯 -->
      <batch-operate-item :text="$t(`actionTitles.edit`)" @click="onRenameliveClick" :disabled="selectedRowKeys.length>1" v-if="type==5">
        <template v-slot:icon>
          <a-icon type="edit" />
        </template>
      </batch-operate-item>
      <!-- 重命名 -->
      <batch-operate-item :text="$t('actionTitles.rename')" @click="onRenameClick" :disabled="selectedRowKeys.length>1" v-else>
        <template v-slot:icon>
          <a-icon type="edit" />
        </template>
      </batch-operate-item>
      <batch-operate-item :text="$t('actionTitles.moveTo')" @click="batchMove">
        <template v-slot:icon>
          <a-icon type="retweet" />
        </template>
      </batch-operate-item>
    </batch-operate>
    <!-- 樹狀彈窗-->
    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="moveTo"
      keyboard
    >
      <a-directory-tree
        :replaceFields="{children:'children', title:'name', key:'id'}"
        :load-data="onLoadData"
        :loadedKeys="loadedKeys"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
        ref="tree"
      />
    </a-modal>

    <!--重命名編輯-->
    <a-modal v-model="renameVisible" :title= "$t(`actionTitles.edit`)" :destroyOnClose="true" @ok="savelive" v-if="type==5">
    <upload-Panolive 
        ref="panoramiclive"
        :dir_id="dir_id"
        @cancel="cancelUpFile"
        :form="form"
    ></upload-Panolive>
    </a-modal>
    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="onRenameConfirm" v-else>
    
      <div>
        <div>
          <a-input v-model="renameObj.name" :addonBefore="$t('edit.name')"></a-input>
        </div>
      </div>
    </a-modal>

    <!-- 預覽圖片 -->
    <a-modal v-model="previewPicVisible" :title="$t('actionTitles.preview')" centered :footer="null" class="preview-pic-modal">
      <img :src="previewPicUrl"/>
    </a-modal>

    <!-- 預覽音頻 -->
    <a-modal v-model="previewAudioVisible" width="80%" centered :destroyOnClose="true" :title="$t('actionTitles.preview')" :footer="null" class="prieview-audio-modal">
      <audio ref="pre-audio" style="width: 100%;" controls="controls" alt="example" :src="previewAudioUrl" preload="none"></audio>
    </a-modal>

    <!-- 預覽視頻 -->
    <a-modal v-model="previewVideoVisible" width="80%" centered :destroyOnClose="true" :closable="false" :footer="null" class="prieview-video-modal">
      <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :options="videoPlayerOptions"
              :playsinline="true"
              customEventName="customstatechangedeventname"
      ></video-player>
    </a-modal>
  </div>
</template>
<style>
  .preview-pic-modal .ant-modal-body,
  .prieview-audio-modal .ant-modal-body{
    padding: 15px;
  }
  .prieview-video-modal .ant-modal-content
  {
    background-color: transparent;
    box-shadow: none;
  }
  .prieview-video-modal .ant-modal-body{
    padding: 0;
  }
  .prieview-video-modal .video-player {
    padding: 10px;
    border-radius: 6px;
    background-color: #121212;
  }
</style>
<style lang="less" scoped>
  .preview-pic-modal{
    img{
      width: 100%;
    }
  }
.content-container {
  background-color: #fff;
  min-height: 100vh;
}

.material-wrapper {
  padding: 0 10px;
  width: 100vw;

  .info-wrapper {
    padding: 10px 0 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #efeeee;
    .left-wrapper {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
        .imgs{
            width: 40px; height: 40px;
        }
    }
    .right-wrapper {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .checkboxes{
        width: 40px;
        height: 40px;
        justify-content: center;
      }
    }
    .material-info {
      margin-left: 10px;
    }
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 100;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
    }
  }
}
</style>

<script>
import Vue from "vue";
import {
  Cell,
  CellGroup,
  List,
  PullRefresh,
  Search,
  Button,
  NavBar,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Icon,
} from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(CheckboxGroup);

import "../../../../../assets/css/mobile.less";
import { mapGetters } from "vuex";
import BatchOperate from "../../../../components/BatchOperate";
import BatchOperateItem from "../../../../components/BatchOperateItem";
import DragUploader from "@/components/DragUploader";
import UploadPanolive from "@/components/UploadPanolive";

import {
  materialPageQuery,
  softDelete,
  regain,
  save,
  rename,
  getFolderDepth,
  querySub,
  moveDir,
  materialAdd,
} from "@/api/planeMaterial";
export default {
  components: { BatchOperate, BatchOperateItem, DragUploader,UploadPanolive },
  props: {
    type: {
      type: Number,
      require: true,
    },
    searchKey: {
      type: String,
      default: "",
    },
    // form:{
    //       cover: "",
    //     },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    searchKey(value) {
      console.log('searchKey',value)
      this.searchForm.name = value;
    },
  },
  data() {
    return {
      searchForm: {
        pid: 0,
        name: this.searchKey,
        type: this.type,
        order: {},
      },
      refreshing: false,
      loading: false,
      finished: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      materialList: [],
      selectedRowKeys: [],
      folderDepthList: [],
      treeVisible: false,
      loadedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      selectedKeys: [],
      selectDirIds: [],
      renameVisible: false,
      renameObj: {},
      newName: "",
      upModelVisible: false,
      isLivePanoramicModel:false,
      dir_id: 0,
      form:{},

      previewPicVisible: false,
      previewPicUrl: '',
      previewAudioVisible: false,
      previewAudioUrl:'',
      previewVideoVisible: false,
      videoPlayerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,瀏覽器準備好時開始回放。
        muted: false, // 默認情況下將會消除任何音頻。
        loop: false, // 導致視頻一結束就重新開始。
        preload: "auto", // 建議瀏覽器在<video>加載元素後是否應該開始下載視頻數據。auto瀏覽器選擇最佳行為,立即開始加載視頻（如果瀏覽器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 將播放器置於流暢模式，並在計算播放器的動態大小時使用該值。值應該代表一個比例 - 用冒號分隔的兩個數字（例如"16:9"或"4:3"）
        fluid: true, // 當true時，Video.js player將擁有流體大小。換句話說，它將按比例縮放以適應其容器。
        sources: [
          {
            type: "", //這裡的種類支持很多種：基本視頻格式、直播、流媒體等，具體可以參看git網址項目
            src: "", //url地址
          },
        ],
        notSupportedMessage: "this.$t('tour.message.videoMsg')", //允許覆蓋Video.js無法播放媒體源時顯示的默認信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按鈕
        },
      },
    };
  },
  created() {},
  mounted() {
    // this.onRefresh();
  },
  methods: {
    previewModal(data){
      console.log('xxxx',data)
      if(data.type==1){
        this.previewPicVisible=true
        this.previewPicUrl=data.url
      }else if(data.type==2){
        this.previewAudioVisible=true
        this.previewAudioUrl = data.url
        //處理手機上不顯示時間的問題
        this.$nextTick(()=> {
          console.log(this.$refs["pre-audio"])
        })
      }else if(data.type==3 || data.type==4){
        this.previewVideoVisible=true
        this.videoPlayerOptions.sources = [{ src: data.url }];
      }
    },
    getKey(item) {
      if (item.dir_id == undefined) {
        return "dir" + item.id;
      } else {
        return item.id + "";
      }
    },
    getId(key) {
      return key.replace("dir", "");
    },
    onRefresh() {
      console.log('onrefresh')
      this.selectedRowKeys = [];
      this.pagination.current = 1;
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      this.loadData();
      getFolderDepth({ id: this.searchForm.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    onLoadMore() {
      this.pagination.current += 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      materialPageQuery(this.searchParam)
        .then((ret) => {
          this.loading = false;
          let data = ret.data.records.map((item) => {
            item.id = this.getKey(item);
            return item;
          });
          if (this.refreshing) {
            this.materialList = data;
          } else {
            this.materialList = [...this.materialList, ...data];
          }
          this.refreshing = false;

          if (data.length < this.pagination.pageSize) {
            this.finished = true;
          }
          this.pagination.total = ret.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onBatchClose() {
      this.selectedRowKeys = [];
    },
    onBatchAll() {
      if(this.selectedRowKeys.length<this.materialList.length){
        this.$refs.checkboxGroup.toggleAll(true);
      }else{
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    batchDelete() {
      let delArr = [];
      this.selectedRowKeys.forEach((key) => {
        let delInfo = { id: this.getId(key) };
        if (key.indexOf("dir") > -1) {
          delInfo.type = "dir";
        } else {
          delInfo.type = "material";
        }
        delArr.push(delInfo);
      });
      this.softDelete(delArr);
    },
    softDelete(delArr) {
      softDelete(delArr).then((res) => {
        this.$message.success(this.$t("message.deleteSuccess"));
        this.onRefresh();
      });
    },
    toFolder(key) {
      this.searchForm.pid = this.getId(key);
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    queryByPid(pid) {
      this.searchForm.pid = pid;
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    batchMove() {
      this.selectDirIds = [];
      this.selectedRowKeys.map((key) => {
        if (key.indexOf("dir")) {
          this.selectDirIds.push(this.getId(key));
        }
      });

      this.treeVisible = true;
      this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }];
      this.loadedKeys = [];
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        setTimeout(() => {
          querySub({ pid: treeNode.dataRef.id, type: this.type }).then(
            (res) => {
              if (res.code && res.data.length) {
                treeNode.dataRef.children = res.data.filter((item) => {
                  if (!this.selectDirIds.includes(item.id)) {
                    return item;
                  }
                });
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            }
          );
        }, 1);
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    moveTo() {
      if (!this.selectedKeys.length) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      let dir = [];
      let pano = [];
      this.selectedRowKeys.forEach((key) => {
        if (key.indexOf("dir") > -1) {
          dir.push(this.getId(key));
        } else {
          pano.push(this.getId(key));
        }
      });

      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then(() => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.onRefresh();
      });
    },
    onRenameClick() {
      this.newName = "";
      let key = this.selectedRowKeys[0];
      this.renameObj = this.materialList.find((p) => {
        return p.id == key;
      });
      this.renameVisible = true;
    },
    onRenameliveClick(){
         this.newName = "";
      let key = this.selectedRowKeys[0];
      this.form = this.materialList.find((p) => {
        return p.id == key;
      });
      this.renameVisible = true;

    },
    onRenameConfirm() {
      if (this.renameObj.dir_id == undefined) {
        //文件夾
        save({
          ...this.renameObj,
          ...{ id: this.getId(this.renameObj.id) },
        }).then(() => {
          this.$message.success(this.$t("message.saveSuccess"));
          this.renameVisible = false;
          this.onRefresh();
        });
      } else {
        //素材
        rename(this.renameObj).then(() => {
          this.$message.success(this.$t("message.saveSuccess"));
          this.renameVisible = false;
          this.onRefresh();
        });
      }
    },
    showUpModel() {
      this.replace_id = 0;
      this.upModelVisible = true;
    },
    cancelUpFile() {
      // this.upModelVisible = false;
      // this.$refs.uploader.delFile();
      if (this.UpModelVisible) {
        this.UpModelVisible = false;
        this.$refs.uploader.delFile();
      } else {
        this.renameVisible = false;
      }
    },
    // 全景自播
    savelive() {
      if(this.form.dir_id == undefined){
        this.$refs.panoramiclive.savePanoramic();
      }else{
        this.cancelUpFile();
        rename(this.form).then((res) => {
              this.$message.success(this.$t("message.saveSuccess"));
              this.onRefresh();
              //this.loadData();
            });
      }
    },
  },
};
</script>

